import React from "react";
import {useState,useEffect} from "react"
import styled from "styled-components";
import { Marginer } from "../../Components/Marginer";
import Logo from "../../Assets/Hnet.com-image.png"
import { FileUploader } from "react-drag-drop-files";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Backpanel from "../../Assets/flowers.jpg"

const PageHolder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const HeaderDiv = styled.div`
    width: 100%;
    height: 21vh;
    display: flex;
    flex-direction: column;
    background-color: #443C54;
    align-items: center;

    @media (max-width: 900px) {
        justify-content:center;
    }
`;

const Logoimg = styled.img`
    width: 190px;
    height: auto;
    margin-top: 1.8vw;

    @media (max-width: 900px) {
        margin-top: 5px;
    }

    &:hover{
        cursor:pointer;
    }

`;


const BottomLine = styled.div`
    width: 70vw;
    height: 1px;
    margin-top: 0.9vw;
    background-color: #ffffff6a;
    border-radius: 80%;
    box-shadow: 0px 2px 7px 2px #353535;

    @media (max-width: 900px) {
        width: 90vw;
        margin-top: 3vw;
    }

`;

const Linkholder = styled.div`
    width: 60vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @media (max-width: 900px) {
        width: 90vw;
    }

    @media (min-width: 900px) and (max-width: 1400px) {
        width: 70vw;
    }

`;



const LinkButton = styled.button`
    width:7vw;
    height:1.5vw;
    background-color: #443C54 ;
    border:0px;
    color: white;
    font-size: 1.1vw;

    &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 600px) {
        width: 35vw;
        font-size: 3.4vw;
        font-weight: bold;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        width: 16vw;
        font-size: 2.4vw;
        font-weight: bold;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        width: 10vw;
        font-size: 1.7vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        width: 9vw;
        font-size: 1.2vw;
    }

  
`;




const EditorHolder = styled.div`
  width: 100%;
  min-height: 140vh;
  display: flex;
  flex-direction: column ;
  align-items: center ;
  justify-content: flex-start ;
`;


const EditorComp = styled.div`
  width: 80vw;
  min-height:80vh;
  background-color: white ;
  border: solid 3px #000000;

  @media (max-width: 600px) {
    width: 90vw;
  }


`;

const TitleText = styled.input`
width: 99.5%;
height: 7vh;
font-size: 2.0vw;
unicode-bidi: plaintext;
border: solid 3px #000000;
direction:rtl;
padding: 10px;


@media (max-width: 600px) {
  height: 2vh;
  font-size: 4.0vw;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    height: 3vh;
    font-size: 3.5vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    height: 4vh;
    font-size: 3.0vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    height: 5vh;
    font-size: 2.5vw;
  }

`;

const TitleField = styled.h1` 
  font-size: 2.1vw;
  color:white;
  text-align: right;

  @media (max-width: 600px) {

  font-size: 4.0vw;
  }

  @media (min-width: 600px) and (max-width: 900px) {

    font-size: 3.5vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {

    font-size: 3.0vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {

    font-size: 2.5vw;
  }

`;

const ErrorFeild = styled.p` 
  font-size: 1vw;
  color: #f52020;
  text-align: right;

  
@media (max-width: 600px) {

font-size: 3.0vw;
}

@media (min-width: 600px) and (max-width: 900px) {

  font-size: 2.5vw;
}

@media (min-width: 900px) and (max-width: 1300px) {

  font-size: 2.0vw;
}

@media (min-width: 1300px) and (max-width: 1700px) {

  font-size: 1.5vw;
}

`;

const TitleHolder = styled.div`
  width:80% ;
  display:flex;
  flex-direction: column;
`;

const Draghere = styled.div`
  
  width: 79vw;
  height: 10vh;
  border: dotted 20px #ffffff6a;
  color: #443C54;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    height: 4vh;
    border-width: 10px;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    height: 6vh;
    border-width: 12px;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    height: 8vh;
    border-width: 14px;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    height: 9vh;
    border-width: 16px;
  }

`;

const Droptext = styled.h1` 
  font-size: 1.8vw;
  color:white;

  @media (max-width: 600px) {

font-size: 4.0vw;
}

@media (min-width: 600px) and (max-width: 900px) {

  font-size: 3.5vw;
}

@media (min-width: 900px) and (max-width: 1300px) {

  font-size: 3.0vw;
}

@media (min-width: 1300px) and (max-width: 1700px) {

  font-size: 2.5vw;
}
`;

const UploadedImage = styled.img`
  max-width: 79vw;
  max-height: 50vh;
  margin: 2vw;
  border: solid 5px #211931;
`;

const SubmitButton = styled.button`
border-radius: 5cm;
border: solid 5px white;
background-color: #211931;
color: #ffffff;
font-size: 1.4vw;
font-weight: bold;
padding: 20px;
margin-bottom: 40px;
min-width: 10vw;
&:hover{
  background-color: #c0c0c0;
  cursor: pointer;
}
&:active{
  background-color: white;
}

@media (max-width: 600px) {

font-size: 4.0vw;
}

@media (min-width: 600px) and (max-width: 900px) {

  font-size: 3.5vw;
}

@media (min-width: 900px) and (max-width: 1300px) {

  font-size: 3.0vw;
}

@media (min-width: 1300px) and (max-width: 1700px) {

  font-size: 2.5vw;
}

`;

const Mainpanel = styled.div`
  
  width:100%;
  min-height: 140vh;
  background-image: url(${Backpanel});
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  background-size: cover;
`;

const MainpanelCover = styled.div`
  width: 100%;
  min-height: 140vh;
  background-color: #00000084;
  display: flex;
  flex-direction: column;
  align-items:center;
`;


const LoginHolder = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column ;
  align-items: center;
  justify-content: center ;
`;

const Logindiv = styled.div`
  width: 40vw;
  min-height: 40vh;
  display: flex;
  flex-direction: column ;
  align-items: center;
  justify-content: center ;
  background-color: #f1f0f0;
  border-radius: 2%;
  border: solid 3px black;
`;

const LoginField = styled.h1` 
  font-size: 1.7vw;
  color:white;
  text-align: right;
  color: #443C54;
  margin-bottom: 40px;
`;

const LoginText = styled.h1` 
  font-size: 1.2vw;
  color:white;
  text-align: right;
  color: #443C54;
`;

const LoginInput = styled.input`
width: 80%;
height: 3vh;
font-size: 1.0vw;
unicode-bidi: plaintext;
border: solid 3px #000000;
padding: 10px;
margin-bottom: 20px;
`;

export function AdminPage(props){
  const navigate = useNavigate();
  let location = useLocation();

  const [file, setFile] = useState(null);
  const [error, setError] = useState(false);
  const [pswderror, setPswderror] = useState(false);
  const [Base64IMG, setBase64IMG] = useState([""]);
  const [password, setPassword] = useState("");
  const [value, setValue] = useState('');
  const [title, setTitle] = useState('');
  const [login,setLogin] = useState(window.localStorage.getItem('login'));

  const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];

  useEffect(() => {
    // setValue('<p class="ql-align-right ql-direction-rtl"><br></p>')
    
    if(location.state){
      setValue(location.state.content)
      setBase64IMG(location.state.image)
      setTitle(location.state.title)
    }

    axios.get('https://salwa-amer-backend.onrender.com/get_blogs')
    .then(res => {
        const blogslist = res.data;
    })
    
},[])
  
  const handleChange = (object) => {
    setFile(object);
    convertToBase64(object);
    console.log(object);
  };


  const modules = {
      toolbar : [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']                                         // remove formatting button
    ]
  };

    const convertToBase64 = (object) => {
      var r = new FileReader();
      r.onload = function(){ 
        
        setBase64IMG(r.result); 
      
      };
      r.readAsDataURL(object);
    }

    async function send_blog(){
      if(title === '' || file===null || value=== '<p class="ql-align-right ql-direction-rtl"><br></p>'){
        setError(true);
        return 
      }
      const response = await axios.post(
        'https://salwa-amer-backend.onrender.com/add_blog',
        { "title": title,"image":Base64IMG,"html": value },
        { headers: { 'Content-Type': 'application/json' } }
      )
      console.log(response.data)
      navigate("/blogs")
    }

    async function edit_blog(){
      if(title === '' || Base64IMG==="" || value==='<p class="ql-align-right ql-direction-rtl"><br></p>'){
        setError(true);
        return 
      }
      const response = await axios.post(
        'https://salwa-amer-backend.onrender.com/edit_blog',
        { "id":location.state.id, "title": title,"image":Base64IMG,"html": value },
        { headers: { 'Content-Type': 'application/json' } }
      )
      console.log(response.data)
      navigate("/admin/blogs")
    }

    function checkpassword(){
      if(password === "damnhour"){
        setLogin(true);
        window.localStorage.setItem('login',true)
      }else{
        setPswderror(true);
      }
    }
    
    return(
        <>
        {login?<>
        
          <PageHolder>
          <HeaderDiv>
          <Logoimg onClick={()=>{navigate("/admin")}} src = {Logo} ></Logoimg>
          <BottomLine/>
          <Marginer height={2} width ={1}></Marginer>
          <Linkholder>
          <LinkButton onClick={()=>{navigate("/admin/blogs")}}> تعديل منشورات</LinkButton>
          <LinkButton onClick={()=>{navigate("/admin")}}> اضافة منشور </LinkButton>
          </Linkholder>
          </HeaderDiv>
          <Mainpanel>
            <MainpanelCover>

          <EditorHolder>
        <TitleHolder>
        <TitleField>:عنوان المنشور</TitleField>
        <TitleText onChange={(e)=>{setTitle(e.target.value)}} defaultValue={location.state?location.state.title:""} type="text"></TitleText>
        <TitleField>:صورة المنشور</TitleField>
        </TitleHolder>
        <Marginer height={1} width ={1}></Marginer>

        
        <FileUploader handleChange={handleChange} name="file" types={fileTypes} hoverTitle={" "}  maxSize={1} multiple={false}>
        <Draghere>
          <Droptext>Drop Here or Upload</Droptext>
        </Draghere>
        </FileUploader>
        {location.state?<><UploadedImage src={location.state.image}/> </>:<>
        {file?<>
          <UploadedImage src={URL.createObjectURL(file)}/>
         </>: <></>}
         </>}
        
        
        <Marginer height={3} width ={1}></Marginer>
        <EditorComp>
        <ReactQuill theme="snow" defaultValue={location.state?location.state.content:`<p class="ql-align-right ql-direction-rtl"><br></p>`} onChange={(e)=>{setValue(e);}} modules={modules} >

        </ReactQuill>
        </EditorComp>
        <Marginer height={3} width ={1}></Marginer>
        {error?<>
         <ErrorFeild>الرجاء ملء كل البيانات</ErrorFeild> 
         </>: <></>}
         {location.state?<><SubmitButton onClick={()=>{edit_blog()}}>قم بالتعديل</SubmitButton> </>:<>
          <SubmitButton onClick={()=>{send_blog()}}>قم بالنشر</SubmitButton>
         </>}
        
        </EditorHolder>
        
        </MainpanelCover>
        </Mainpanel>
        </PageHolder>

        </>:<>
        <Mainpanel>
            <MainpanelCover>

        <LoginHolder>
          <Logindiv>
            <LoginField>تسجيل الدخول</LoginField>
            <LoginText>الرجاء ادخال كلمة السر</LoginText>
            <LoginInput onChange={(e)=>{setPassword(e.target.value)}} type="password"></LoginInput>
            {pswderror?<><ErrorFeild>كلمة السر خطأ</ErrorFeild> </>:<></>}
            <SubmitButton onClick={checkpassword}>الدخول</SubmitButton>
          </Logindiv>
        </LoginHolder>

        </MainpanelCover>
        </Mainpanel>
        </>}
        
        </>

    );
}